import { render, staticRenderFns } from "./SaveSearchBlock.vue?vue&type=template&id=faa97bce"
import script from "./SaveSearchBlock.vue?vue&type=script&lang=js"
export * from "./SaveSearchBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports